import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const ProposalPage = lazy(() => import("../../_features/proposals/pages/ProposalPage"));
const CreateProposalPage = lazy(() => import("../../_features/proposals/pages/ProposalCreatePage"));
const EditProposalPage = lazy(() => import("../../_features/proposals/pages/ProposalEditPage"));
const TemplateEditorPage = lazy(() => import("../../_features/documentManagement/pages/TemplateEditorPage"));

export const proposalRoutes = [
    {
        path: "/sell/proposals", element:
            <FeatureFlagRoute feature="proposals">
                <PermissionRoute permission={ROUTE_PERMISSIONS.proposals.view} moduleName="Proposals">
                    <ProposalPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/sell/proposals/create", element:
            <FeatureFlagRoute feature="proposals">
                <PermissionRoute permission={ROUTE_PERMISSIONS.proposals.create} moduleName="Proposals">
                    <CreateProposalPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/sell/proposals/:id/edit", element:
            <FeatureFlagRoute feature="proposals">
                <PermissionRoute permission={ROUTE_PERMISSIONS.proposals.edit} moduleName="Proposals">
                    <EditProposalPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        // Not permission-gated: TemplateEditorPage here belongs to
        // documentManagement, which has no real permission module in the
        // backend catalog - see routePermissions.js's trailing comment.
        path: "/proposals/template", element:
            <FeatureFlagRoute feature="documentManagement">
                <TemplateEditorPage forcedType="proposal" />
            </FeatureFlagRoute>
    }
];
